import { Button, HStack, Input } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import { IShapeFile } from "../_types_";
import { uploadMultiFile } from "../apis/file.api";

interface IProps {
  title?: string;
  isTimTuyenDuong?: boolean;
  onUploadSuccess?: (file: IShapeFile | string) => void;
}

export default function UploadMutiFile({
  title,
  isTimTuyenDuong,
  onUploadSuccess,
}: IProps) {
  const [fileInfo, setFileInfo] = useState<IShapeFile | string>();

  const handleUploadFile = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      try {
        if (event.target.files) {
          const file = await uploadMultiFile(
            event.target.files,
            isTimTuyenDuong
          );
          if (file) {
            setFileInfo(file);
            onUploadSuccess && onUploadSuccess(file);
          }
        }
      } catch (er) {
        console.log(er);
      }
    },
    [isTimTuyenDuong, onUploadSuccess]
  );

  return (
    <HStack position="relative" bg="white" w="full">
      <Input
        borderRadius="0px"
        placeholder={`Chọn file ${title}...`}
        value={
          typeof fileInfo === "string"
            ? "Đã tải tệp lên"
            : fileInfo?.fileId || ""
        }
      />
      <Button
        position="absolute"
        right="0"
        borderRadius="0px"
        bg="blue.700"
        color="white"
      >
        File upload
      </Button>
      <Input
        type="file"
        height="100%"
        width="100%"
        position="absolute"
        top="0"
        left="0"
        opacity="0"
        aria-hidden="true"
        accept=".shp,.shx, .dbf"
        multiple
        onChange={handleUploadFile}
      />
    </HStack>
  );
}
